import { render, staticRenderFns } from "./survey-widget.vue?vue&type=template&id=ed2bec7a&scoped=true&"
import script from "./survey-widget.vue?vue&type=script&lang=js&"
export * from "./survey-widget.vue?vue&type=script&lang=js&"
import style0 from "./survey-widget.vue?vue&type=style&index=0&id=ed2bec7a&prod&scoped=true&lang=css&"
import style1 from "./survey-widget.vue?vue&type=style&index=1&id=ed2bec7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2bec7a",
  null
  
)

export default component.exports